import actions from './actions';

const initState = {
    categoryInfo: {},
    categories   : {
        data: []
    },
    loading : false,
    categoryDeleted : false,
    message: null,
    status: null
};

export default function fetchCategoriesReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_CATEGORIES_REQUESTED:
            return {
                ...state,
                categories   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_CATEGORIES_SUCCEEDED:
            return {
                ...state,
                categories  : action.categories,
                loading     : false
            };
        case actions.FETCH_CATEGORIES_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_CATEGORY_REQUESTED:
            return {
                ...state,
                categoryInfo: {},
                loading : true
            };
        case actions.FETCH_CATEGORY_SUCCEEDED:
            return {
                ...state,
                categoryInfo: action.category,
                loading     : false
            };
        case actions.FETCH_CATEGORY_FAILED:
            return {
                ...state,
                loading : false
            };

        case actions.DELETE_CATEGORY_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.DELETE_CATEGORY_SUCCEEDED:
            return {
                ...state,
                loading     : false,
                categoryDeleted : true,
                message: "Category deleted successfully!",
                status: 200
            };
        case actions.DELETE_CATEGORY_FAILED:
            return {
                ...state,
                loading : false,
                message: action?.error?.message,
                status: action?.error?.status
            };
        case actions.CLEAR_ALERT_MESSAGE:
            return {
                ...state,
                message: null,
                status: null
            };
        default:
            return state;
    }
}
